import {take, put, call} from 'redux-saga/effects';
import {ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED} from '@computerrock/formation-router';
import {efServiceAssignmentTypes, efServiceCaseTypes} from '@ace-de/eua-entity-types';
import updateServiceAssignment from '../../service-assignments/sagas/updateServiceAssignment';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import * as sastActionTypes from '../sastActionTypes';
import sendAttachmentsWithAssignmentFlow from '../../service-cases/sagas/sendAttachmentsWithAssignmentFlow';

/**
 * Update SAST cost coverage flow
 */
const updateSASTCostCoverageFlow = function* updateSASTCostCoverageFlow() {
    while (true) {
        const {payload} = yield take(sastActionTypes.SUBMIT_SAST_COST_COVERAGE_FORM);
        const {
            serviceAssignmentLineNo,
            serviceAssignmentData,
            serviceCaseId,
            serviceCaseData,
            nonAceMember,
            attachmentsToSendWithAssignment,
        } = payload;

        yield call(sendAttachmentsWithAssignmentFlow, {
            caller: sastActionTypes.SUBMIT_SAST_COST_COVERAGE_FORM,
            attachmentsToSendWithAssignment,
            serviceCaseId,
        });

        yield* updateServiceAssignment({
            caller: sastActionTypes.SUBMIT_SAST_COST_COVERAGE_FORM,
            assignmentType: efServiceAssignmentTypes.SHORT_TRIP,
            serviceAssignmentLineNo,
            serviceCaseId,
            serviceAssignmentData,
        });

        if (nonAceMember) {
            yield* updateServiceCase({
                caller: sastActionTypes.SUBMIT_SAST_COST_COVERAGE_FORM,
                caseType: efServiceCaseTypes.VEHICLE,
                serviceCaseId,
                serviceCaseData,
            });
        }

        yield put({
            type: ROUTE_UNMOUNT_SIDE_EFFECT_COMPLETED,
            payload: {caller: sastActionTypes.SUBMIT_SAST_COST_COVERAGE_FORM},
        });
    }
};

export default updateSASTCostCoverageFlow;
